




































































































































































































































import {
  computed,
  defineComponent,
  defineVue3AsyncComponent,
  ref,
  onMounted,
  onUnmounted,
  useRoute,
  onActivated,
  onDeactivated,
  watch
} from '~/utils/nuxt3-migration'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import ViewTypeSelector from '~/components/car/classifieds/search/results/header/ViewTypeSelector.vue'
import ClassifiedSearchResultsPagination from '~/components/car/classifieds/search/results/ClassifiedSearchResultsPagination.vue'
import { CategoryId } from '~/models/category/types'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import MassActionsCategorySelect from '~/components/car/classifieds/search/results/mass-actions/MassActionsCategorySelect.vue'
import { Permission } from '~/constants/permission'
import ClassifiedSearchResultsMakeProductsBanner from '~/components/car/classifieds/search/results/ClassifiedSearchResultsMakeProductsBanner.vue'
import { formatNumber } from '~/utils/number'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { useNamespacedStore } from '~/compositions/store'
import { Option } from '~/models/shared/types'
import { SET_PARAM } from '~/store/modules/shared/classifieds/search/mutation-types'
import { ciSort } from '~/icons/source/regular/sort'
import { ciShare } from '~/icons/source/regular/share'
import { ciMap } from '~/icons/source/regular/map'
import { ciCompare } from '~/icons/source/regular/compare'
import { ciFilters } from '~/icons/source/regular/filters'
import { ciGalleryTiles } from '~/icons/source/regular/gallery-tiles'
import { ciListView } from '~/icons/source/regular/list-view'
import { ciBin } from '~/icons/source/regular/bin'
import { ciBookmark as ciBookmarkRegular } from '~/icons/source/regular/bookmark'
import { ciBookmark as ciBookmarkSolid } from '~/icons/source/solid/bookmark'
import { ciVerticalDots } from '~/icons/source/regular/vertical-dots'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import { useDeps } from '~/compositions/dependency-container'
import { STORAGE_NS, StorageState } from '~/store/modules/shared/storage/state'
import { useUserAgent } from '~/compositions/user-agent'
import CButtonGroup from '~/components/shared/configurable/button/CButtonGroup.vue'
import CompareService from '~/services/compare/CompareService'
import { useAppConfirmationModal } from '~/compositions/app-confirmation-modal'
import ClassifiedSearchResultsSelectedHandlers from '~/components/car/classifieds/search/results/ClassifiedSearchResultsSelectedHandlers.vue'
import CShareButtons from '~/components/shared/configurable/social/CShareButtons.vue'
import CContextMenu from '~/components/shared/configurable/CContextMenu.vue'
import CShareModal from '~/components/shared/configurable/social/CShareModal.vue'
import { resolveCategory } from '~/utils/category'
import { ciCars } from '~/icons/source/thin/cars'
import { ciMagnifyingGlass } from '~/icons/source/regular/magnifying-glass'
import { ciPartsAccessories } from '~/icons/source/thin/parts-accessories'
import { ciWantedParts } from '~/icons/source/thin/wanted-parts'
import { ciMarketplace } from '~/icons/source/thin/marketplace'
import { ciJobs } from '~/icons/source/thin/jobs'
import { ciRentals } from '~/icons/source/solid/rentals'
import { ciBicycles } from '~/icons/source/thin/bicycles'
import { ciMotorbikes } from '~/icons/source/thin/motorbikes'
import { ciMotorhomes } from '~/icons/source/thin/motorhomes'
import { ciBlackFriday } from '~/icons/source/brand/black-friday'
import { ciDeals } from '~/icons/source/thin/deals'
import { ciCaravans } from '~/icons/source/thin/caravans'
import { ciTaxis } from '~/icons/source/thin/taxis'
import { ciTrailers } from '~/icons/source/thin/trailers'
import { ciForklifts } from '~/icons/source/thin/forklifts'
import { ciBuses } from '~/icons/source/thin/buses'
import { ciSemitrailers } from '~/icons/source/thin/semitrailers'
import { ciSemitrucks } from '~/icons/source/thin/semitrucks'
import { ciBuilders } from '~/icons/source/thin/builders'
import { ciTractors } from '~/icons/source/thin/tractors'
import { ciTrucks } from '~/icons/source/thin/trucks'
import { ciVans } from '~/icons/source/thin/vans'
import { ciBoats } from '~/icons/source/thin/boats'
import { ciGokarts } from '~/icons/source/thin/gokarts'
import { ciAirsport } from '~/icons/source/light/airsport'
import { ciWatersports } from '~/icons/source/thin/watersports'
import { ciHobbies } from '~/icons/source/thin/hobbies'
import { ciSnowsports } from '~/icons/source/thin/snowsports'
import Searchbar from '~/components/shared/classified/search/searchbar/Searchbar.vue'
import { ciRealEstate } from '~/icons/source/thin/real-estate'
import ClassifiedSearchSaveSearchModal from '~/components/car/classifieds/search/ClassifiedSearchSaveSearchModal.vue'

const partsParentCategoriesIds = [
  CategoryId.PARTS_CARS,
  CategoryId.PARTS_TRACTORS,
  CategoryId.PARTS_BUILDERS,
  CategoryId.PARTS_TRUCKS,
  CategoryId.PARTS_FORKLIFTS,
  CategoryId.PARTS_BUSES,
  CategoryId.PARTS_BIKES,
  CategoryId.PARTS_BICYCLES,
  CategoryId.PARTS_BOATS
]

export default defineComponent({
  components: {
    ClassifiedSearchSaveSearchModal,
    Searchbar,
    CShareModal,
    CContextMenu,
    CButtonGroup,
    CShareButtons,
    ClassifiedSearchResultsSelectedHandlers,
    CCustomSelect,
    ClassifiedSearchResultsMakeProductsBanner,
    MassActionsCategorySelect,
    ClassifiedSearchResultsPagination,
    ViewTypeSelector,
    MassActions: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/results/mass-actions/MassActions.vue'
      )
    ),
    MassRemoveButton: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/results/header/MassRemoveButton.vue'
      )
    ),
    MassRestoreButton: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/search/results/header/MassRestoreButton.vue'
      )
    ),
    AutoRefreshButton: defineVue3AsyncComponent(() =>
      import('~/components/car/wanted-parts/AutoRefreshButton.vue')
    )
  },
  setup() {
    const {
      state: classifiedSearchState,
      dispatch: classifiedSearchDispatch,
      commit: classifiedSearchCommit,
      getters: classifiedSearchGetters
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const { getters: storageGetters } = useNamespacedStore<StorageState>(
      STORAGE_NS
    )
    const { t } = useI18n()
    const route = useRoute()
    const { isPc, isMobile } = useUserAgent()
    const [dealerSiteService, compareService] = useDeps(
      DealerSiteService,
      CompareService
    )
    const confirm = useAppConfirmationModal()

    const sortFields = computed(() => classifiedSearchState.sortFields)

    watch(sortFields, () => {
      selectedSortValue.value = sortFields.value?.find(
        field => field.selected
      )?.value
    })

    const selectedSortValue = ref(
      sortFields.value?.find(field => field.selected)?.value
    )
    const isCompareDeleteButtonLoading = ref(false)
    const isSaveSearchModalShown = ref(false)
    const isShareModalVisible = ref(false)
    const saveSearchLoading = ref(false)
    const isMobileTopBarScrolled = ref(false)
    const headerElement = process.client
      ? (document.querySelector('#header-container') as HTMLElement)
      : null

    onActivated(() => {
      if (isMobile.value) {
        if (headerElement) {
          headerElement.style.transform = `translateY(0)`
        }
        window.addEventListener('scroll', onScroll)
      }
    })

    onDeactivated(() => {
      if (isMobile.value) {
        if (headerElement) {
          headerElement.style.transform = `translateY(0)`
        }
        window.removeEventListener('scroll', onScroll)
      }
    })

    onMounted(() => {
      if (isMobile.value) {
        window.addEventListener('scroll', onScroll, { passive: true })
      }
    })

    onUnmounted(() => {
      if (isMobile.value) {
        if (headerElement) {
          headerElement.style.transform = `translateY(0)`
        }
        window.removeEventListener('scroll', onScroll)
      }
    })

    const qFacet = computed(() => classifiedSearchGetters('getQFacet'))

    const mapSearchUrl = computed(() => classifiedSearchState.mapSearchUrl)

    const categoryIds = computed(() => classifiedSearchState.categoryIds)

    const isDeletedSearch = computed(
      () => classifiedSearchState.config.settings.isDeletedSearch
    )

    const searchCanBeSaved = computed(() => classifiedSearchState.canBeSaved)

    const searchIsFavorite = computed(() => classifiedSearchState.isFavorite)

    const previousSearch = computed(() => classifiedSearchState.previousSearch)

    const showSellers = computed(() => classifiedSearchGetters('showSellers'))

    const discountFacet = computed(() =>
      classifiedSearchGetters('getFacetByName')('discount')
    )

    const selectedFacetsCount = computed(() =>
      classifiedSearchGetters('getFacetsCount')
    )

    const totalRows = computed(() => classifiedSearchGetters('getTotalRows'))

    const showMassActions = computed(() =>
      classifiedSearchGetters('showMassActions')
    )

    const isWantedPartsSearch = computed(() =>
      classifiedSearchGetters('isWantedPartsSearch')
    )

    const rootCategoryId = computed(() =>
      classifiedSearchGetters('getCurrentCategoryId')
    )

    const inBlackFridaySearch = computed(() =>
      classifiedSearchGetters('inBlackFridaySearch')
    )

    const inDealsSearch = computed(() =>
      classifiedSearchGetters('inDealsSearch')
    )

    const isOfTypeDealer = computed(() => userGetters('isOfTypeDealer'))

    const isEshopOnboardingSearch = computed(
      () => !!route.value.query.eshop_onboarding
    )

    const sortFieldsOptions = computed<Option[]>(() =>
      classifiedSearchState.sortFields?.map(field => ({
        label: field.name,
        value: field.value
      }))
    )

    const viewTypeIcon = computed(() =>
      classifiedSearchState.viewType === 'list' ? ciGalleryTiles : ciListView
    )

    const saveSearchIcon = computed(() =>
      searchIsFavorite.value ? ciBookmarkSolid : ciBookmarkRegular
    )

    const showViewTypeButton = computed(
      () => !showSellers.value && !isWantedPartsSearch.value
    )

    const totalResultsText = computed(() => {
      const suffix = showSellers.value ? t('sellers') : t('classifieds')

      return `${formatNumber(totalRows.value)} ${suffix}`.toLowerCase()
    })

    const inMyClassifiedsSearch = computed(
      () => route.value.name === '__classifieds_search_my_classifieds'
    )

    const title = computed(() => {
      const shortTitle = classifiedSearchState.shortTitle

      if (!shortTitle?.length) {
        return t('search')
      }

      const lastTitlePart = shortTitle[shortTitle.length - 1].value

      // Show the "My Classifieds" prefix when the user is viewing their own classifieds
      // to make it clear that they are viewing their own classifieds and not the general search results
      if (inMyClassifiedsSearch.value && shortTitle.length > 1) {
        return `${t('my classifieds')} | ${lastTitlePart}`
      }

      const currentCategoryId =
        categoryIds.value?.[categoryIds.value.length - 1]
      if (
        currentCategoryId &&
        partsParentCategoriesIds.includes(currentCategoryId)
      ) {
        // Add the "Parts" prefix to the title for some parent parts categories
        // to make it clear that the user is viewing parts
        return t('parts_title', { category: lastTitlePart })
      }

      return lastTitlePart
    })

    const showMassActionCategorySelect = computed(() => {
      if (showMassActions.value) {
        return false
      }

      const isDealerSiteRoute = dealerSiteService.routeIsOfDealerSite()
      const inClassifiedSearch = categoryIds.value.some(
        (c: CategoryId) => c === CategoryId.CLASSIFIEDS
      )

      return (
        inMyClassifiedsSearch.value &&
        !isDealerSiteRoute &&
        isOfTypeDealer.value &&
        userGetters('hasPermission')(Permission.MASS_ACTIONS) &&
        inClassifiedSearch &&
        !isDeletedSearch.value &&
        !isEshopOnboardingSearch.value
      )
    })

    const showCompareButton = computed(() => {
      if (
        !classifiedSearchState.config.settings.isCompareButtonVisible ||
        classifiedsToCompareCount.value === 0
      ) {
        return false
      }

      const isDealerSiteRoute = dealerSiteService.routeIsOfDealerSite()

      return (
        !isDealerSiteRoute &&
        !isDeletedSearch.value &&
        !isEshopOnboardingSearch.value
      )
    })

    const classifiedsToCompareCount = computed(() => {
      const compareStorageItems = storageGetters('getItem')('compare')

      if (!compareStorageItems || !rootCategoryId.value) {
        return 0
      }

      return compareStorageItems[rootCategoryId.value]?.length || 0
    })

    const compareUrl = computed(() =>
      compareService.createCompareUrl(rootCategoryId.value)
    )

    const discountsUrl = computed(() => {
      if (!discountFacet.value) {
        return null
      }

      return discountFacet.value.values?.discounts_seo_url
    })

    const titleIcon = computed(() => {
      if (inBlackFridaySearch.value) {
        return ciBlackFriday
      }

      if (inDealsSearch.value) {
        return ciDeals
      }

      return (
        resolveCategory(
          {
            [CategoryId.CARS]: ciCars,
            [CategoryId.BIKES]: ciMotorbikes,
            [CategoryId.PARTS]: ciPartsAccessories,
            [CategoryId.WANTED_PARTS]: ciWantedParts,
            [CategoryId.XYMA]: ciMarketplace,
            [CategoryId.JOBS]: ciJobs,
            [CategoryId.RENTALS]: ciRentals,
            [CategoryId.BICYCLES]: ciBicycles,
            [CategoryId.MOTORHOMES]: ciMotorhomes,
            [CategoryId.CARAVANS]: ciCaravans,
            [CategoryId.TAXIS]: ciTaxis,
            [CategoryId.TRAILERS]: ciTrailers,
            [CategoryId.FORKLIFTS]: ciForklifts,
            [CategoryId.BUSES]: ciBuses,
            [CategoryId.SEMITRAILERS]: ciSemitrailers,
            [CategoryId.SEMITRUCKS]: ciSemitrucks,
            [CategoryId.BUILDERS]: ciBuilders,
            [CategoryId.TRACTORS]: ciTractors,
            [CategoryId.TRUCKS]: ciTrucks,
            [CategoryId.VANS]: ciVans,
            [CategoryId.BOATS]: ciBoats,
            [CategoryId.HOBBY]: ciHobbies,
            [CategoryId.GOKARTS]: ciGokarts,
            [CategoryId.AIRSPORTS]: ciAirsport,
            [CategoryId.WATERSPORTS]: ciWatersports,
            [CategoryId.RADIOCONTROLS]: ciHobbies,
            [CategoryId.SNOWSPORTS]: ciSnowsports,
            [CategoryId.PLOT]: ciRealEstate
          },
          categoryIds.value
        ) || ciMagnifyingGlass
      )
    })

    const titleIconClass = computed(() => {
      if (inBlackFridaySearch.value) {
        return 'tw-text-black'
      }

      return (
        resolveCategory(
          {
            [CategoryId.RENTALS]: 'tw-text-green-800',
            [CategoryId.TAXIS]: 'tw-text-yellow-700'
          },
          categoryIds.value
        ) || 'tw-text-blue'
      )
    })

    function onSortChange(value: string) {
      classifiedSearchCommit(SET_PARAM, { name: 'sort', value })
      classifiedSearchCommit(SET_PARAM, { name: 'pg', value: 1 })

      classifiedSearchDispatch('search')
    }

    function onViewTypeButtonClick() {
      classifiedSearchDispatch(
        'viewTypeChanged',
        classifiedSearchState.viewType === 'list' ? 'gallery' : 'list'
      )
    }

    function onDeleteCompareItemsButtonClick() {
      confirm.show({
        variant: 'danger',
        title: t('delete comparison'),
        text: t(
          'are you sure you want to remove the classifieds from comparison?'
        ),
        confirmButtonText: t('remove'),
        centered: true,
        size: 'sm',
        onConfirm: async () => {
          isCompareDeleteButtonLoading.value = true
          await compareService.deleteComparedCategory(rootCategoryId.value)
          isCompareDeleteButtonLoading.value = false
        }
      })
    }

    async function onSaveSearchButtonClick() {
      if (searchIsFavorite.value) {
        saveSearchLoading.value = true
        await classifiedSearchDispatch('removeFromFavorites')
        saveSearchLoading.value = false
      } else {
        isSaveSearchModalShown.value = true
      }
    }

    function onFiltersButtonClick() {
      classifiedSearchDispatch('toggleMobileFacets')
    }

    function onScroll() {
      requestAnimationFrame(() => {
        if (!headerElement) {
          return
        }

        const scrollTop = window.scrollY || document.documentElement.scrollTop

        headerElement.style.transform =
          scrollTop > 35 ? `translateY(-56px)` : `translateY(0)`
        isMobileTopBarScrolled.value = scrollTop > 92
      })
    }

    return {
      ciSort,
      ciShare,
      ciMap,
      ciCompare,
      ciBin,
      ciFilters,
      ciVerticalDots,
      viewTypeIcon,
      previousSearch,
      saveSearchIcon,
      isCompareDeleteButtonLoading,
      selectedFacetsCount,
      isPc,
      showCompareButton,
      categoryIds,
      selectedSortValue,
      sortFieldsOptions,
      mapSearchUrl,
      showViewTypeButton,
      totalResultsText,
      title,
      isEshopOnboardingSearch,
      showMassActions,
      showMassActionCategorySelect,
      isDeletedSearch,
      showSellers,
      isWantedPartsSearch,
      classifiedsToCompareCount,
      compareUrl,
      searchCanBeSaved,
      searchIsFavorite,
      isSaveSearchModalShown,
      saveSearchLoading,
      isShareModalVisible,
      isMobileTopBarScrolled,
      titleIcon,
      titleIconClass,
      qFacet,
      discountsUrl,
      onSortChange,
      onFiltersButtonClick,
      onViewTypeButtonClick,
      onDeleteCompareItemsButtonClick,
      onSaveSearchButtonClick
    }
  },
  i18n: defineComponentTranslations({
    change_view_type: {
      en: 'Change view',
      el: 'Αλλαγή προβολής'
    },
    show_comparison: {
      en: 'Show comparison',
      el: 'Προβολή σύγκρισης'
    },
    parts_title: {
      en: '{category} Parts',
      el: 'Ανταλλακτικά {category}'
    }
  })
})
